import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { captureSsoToken } from './lib/auth';
import './index.css';

// 카카오 SSO 복귀(?sso_token=) 흡수 — 렌더 전에 토큰 저장.
captureSsoToken();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
